export class Form {
    constructor(formTitle, typeOptions, stateOptions) {
        this.formTitle = formTitle;
        this.typeOptions = typeOptions;
        this.stateOptions = stateOptions;
    }

    schema() {
        return [
            {
                'component': 'h2',
                'children': this.formTitle,
            },
            {
                'component': 'div',
                'class': 'row',
                'children': [
                    {
                        'type': 'text',
                        'name': 'headline',
                        'label': 'Stellenbeschreibung',
                        'class': 'col-12',
                        'placeholder': 'Stellenbeschreibung',
                        'validation': 'min:5,length|required',
                        'validation-name': 'Stellenbeschreibung',
                    },
                    {
                        'type': 'checkbox',
                        'name': 'active',
                        'label': 'Aktiv',
                        'class': 'col-12',
                        'validation-name': 'Sichtbarkeit',
                    },
                    {
                        'type': 'editor',
                        'name': 'description',
                        'label': 'Beschreibung',
                        'class': 'col-12',
                        'validation': 'min:5,length|required',
                        'validation-name': 'Beschreibung',
                    },
                    {
                        'type': 'multiselect',
                        'name': 'type',
                        'label': 'Anstellungsart',
                        'class': 'col-12 col-md-6',
                        'placeholder': 'Anstellungsart',
                        'validation': 'required',
                        'options': this.typeOptions,
                        'validation-name': 'Anstellungsart',
                    },
                    {
                        'type': 'text',
                        'name': 'hours',
                        'label': 'Wochenstunden',
                        'class': 'col-12 col-md-6',
                        'validation': 'required|number',
                        'validation-name': 'Wochenstunden',
                        'help': 'Geben Sie hier die Wochenstunden an.',
                    },
                    {
                        'type': 'multiselect',
                        'name': 'state',
                        'label': 'Bundesland',
                        'class': 'col-12 col-md-6',
                        'help': 'Geben Sie hier das Bundesland an.',
                        'placeholder': 'Bundesland',
                        'validation': 'required',
                        'options': this.stateOptions,
                        'validation-name': 'Bundesland',
                    },

                    {
                        'type': 'text',
                        'name': 'salary',
                        'label': 'Mindestbruttomonatsgehalt',
                        'class': 'col-12 col-md-6',
                        'validation': 'required',
                        'help': 'Geben Sie hier das Mindestbruttogehalt in Euro pro Monat an.',
                        'validation-name': 'Mindestbruttomonatsgehalt',
                    },
                ],
            },
        ];
    }
}
